// extracted by mini-css-extract-plugin
module.exports = {"orderedList":"OrderedList_orderedList__LOVog"};